import * as React from 'react';
import Close from '@mui/icons-material/Close';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import i18next from 'i18next';
import { Theme, useTheme } from '@mui/material/styles';
import { observer } from 'mobx-react';

import { DefaultAppProps } from '../App';

import { makeStyles, MakeStylesHook, StyleRules } from '@egr/xbox/utils/tss-react';

type ARSizeClassKey = 'close' | 'row' | 'col' | 'img' | 'title';

function getARSizeStyles(theme: Theme, props: unknown, classes: Record<ARSizeClassKey, string>): StyleRules<{}, ARSizeClassKey> {
    return {
        close: {
            position: 'relative',
            top: -2,
            left: -12,
        },
        row: {
            display: 'flex',
        },
        col: {
            maxWidth: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        img: {
            [`.${classes.col}:not(:first-child) &`]: {
                position: 'relative',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    width: 2,
                    backgroundColor: '#ececec',
                },
            },
            '& img': {
                maxWidth: '100%',
            },
        },
        title: {
            color: theme.palette.primary.main,
            textTransform: 'uppercase',
            fontWeight: 'bold',
            paddingBottom: 16,
            paddingTop: 16,
            fontSize: '0.875rem',
        },
    };
}

const useARSizeStyles: MakeStylesHook<ARSizeClassKey> = makeStyles<void, ARSizeClassKey>({ name: 'ARSize' })(getARSizeStyles);

export const ARSize: React.FC<DefaultAppProps> = observer((props) => {
    const { classes } = useARSizeStyles();
    const theme: Theme = useTheme();

    const handleClose: () => void = () => {
        props.app.viewManager.showARSize(false);
    };

    const handleOriginalSize: () => void = () => {
        props.app.viewManager.showARSize(false);
        void props.app.shareActions.openUSDZinAR(false);
    };

    const handleMiniature: () => void = () => {
        props.app.viewManager.showARSize(false);
        void props.app.shareActions.openUSDZinAR(true);
    };

    return (
        <Dialog
            style={{ zIndex: theme.zIndex.modal + 1 }}
            open={props.app.viewManager.state.showARSize}
            onClose={handleClose}
            onBackdropClick={handleClose}
            maxWidth={false}
        >
            <DialogTitle>
                <IconButton className={classes.close} onClick={handleClose}>
                    <Close />
                </IconButton>
                {i18next.t('AR Size')}
            </DialogTitle>
            <DialogContent>
                <div className={classes.row}>
                    <div className={classes.col} onClick={handleOriginalSize}>
                        <div className={classes.img}><img src="./img/ar_size_original.jpg" /></div>
                        <div className={classes.title}>{i18next.t('Original size')}</div>
                    </div>
                    <div className={classes.col} onClick={handleMiniature}>
                        <div className={classes.img}><img src="./img/ar_size_miniature.jpg" /></div>
                        <div className={classes.title}>{i18next.t('Miniature size')}</div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
});